import React, { useState } from 'react'
import RightArrowIcon from '../../assets/icons/svgComponents/right-arrow-icon'
import Button from '../button'
import Input from '../input'
import * as S from './styles'
import MyAutoComplete from '../autocomplete'
import { makeLoadSchooling } from '../../../main/usecases/load-schooling/load-schooling'

type Props={
  handleClick:()=>void
  isRequired?:boolean
  data:{
    filtroDoConstruto:string
      tipoDeTeste:string
      tipoDeTabela: string,
      escolaridade?: string,
      sexo?: string,
      idade?: string,
      pontuação: string,
    }

    setData:any
    testType:number
}
type ObjProps = {
  cd:string
  nome:string
}
type schoolingProps = {
  cdEscolaridade:string
  escolaridade:string
  ordem:string
}
const SecondStep = ({
  handleClick, data, setData, testType, isRequired,
}:Props) => {
  const [options, setOptions] = useState< Array<ObjProps>>([])
  const [value1, setValue1] = useState('')
  const [value2, setValue2] = useState('')
  const loadSchoolingOption = async () => {
    const loadOptions:Array<schoolingProps> = await makeLoadSchooling().load()
    const auxOptions = loadOptions.map((construct) => {
      const constructList = (Object.values(construct))
      return ({
        cd: constructList[1],
        nome: constructList[1],
      }
      )
    })
    setOptions(auxOptions)
  }

  const firstSelect = [
    <MyAutoComplete
      value={value1}
      setValue={setValue1}
      name="SecondStepFirstSelectFirstOption"
      isRequired
      label="Escolaridade"
      labelColor="black"
      onMenuOpen={() => loadSchoolingOption()}
      onSelect={(e:any) => setData({ ...data, escolaridade: e })}
      options={options}
    />,
    <Input
      name="SecondStepFirstSelectSecondOption"
      required={isRequired}
      label="Idade"
      labelColor="black"
      onChange={(e: any) => setData({ ...data, idade: e.target.value })}
      type="text"
    />,
    <MyAutoComplete
      value={value2}
      setValue={setValue2}
      name="secondSelectSecondStep"
      isRequired
      label="Sexo"
      labelColor="black"
      onSelect={(e:any) => setData({ ...data, sexo: e })}
      options={[
        { nome: 'Masculino', cd: 'Masculino' },
        { nome: 'Feminino', cd: 'Feminino' },
      ]}
    />,
  ]
  return (
    <S.Wrapper>
      <S.ProgressBar>
        <S.Progress stage={2} />
      </S.ProgressBar>
      <h1>Informações sobre o teste aplicado</h1>
      <h2>preencha os campos</h2>
      <form onSubmit={(e) => {
        e.preventDefault()
        handleClick()
      }}
      >
        {firstSelect[testType]}
        <Input
          required={isRequired}
          type="number"
          name="seconStepInput"
          label="Digite a pontuação"
          onChange={(e:any) => setData({ ...data, pontuação: e.target.value })}
          labelColor="black"
        />
        <Button
          type="submit"
          Thisclass="stepButton"
        >
          Prosseguir
          <RightArrowIcon color="white" />
        </Button>
      </form>
    </S.Wrapper>
  )
}
export default SecondStep
